import axiosInstance from '../axiosInterceptor/axiosInstance'

const getLivestream = async (data) => {
  const { broadcastId, orgId } = data
  const url = `v1/orgs/${orgId}/streams/${broadcastId}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getLivestream
